import axios from 'axios'
import baseUrl from './base-url'
import { getValidUrl } from '../util'

export default function({ state }, { url, query }) {
    if (query)
        url = url + '?' + Object.keys(query).map((q) => (q + '=' + query[q])).join('&')
    
    url = getValidUrl(url, state)

    return axios.delete(baseUrl + url, {
            withCredentials: true
        })
        .then((response) => {
            return response.data
        })
        .catch((error) => {
            // console.log('post error', error)
            // console.log('error', JSON.stringify(error.response.data, null, 4))
            throw error.response.data
        })
}
